import "./intro.scss";
import {IconAppWindow, IconCertificate} from '@tabler/icons-react';

export default function Intro(){
    return (
        <div className="intro" id={"intro"}>
            <div className={"left"}>
                <h2 className={"title"}>A propos de moi</h2>
                <span className={"divider"}/>
                <p>Je suis un jeune passionné d'informatique, tourné vers les nouvelles technologies depuis mon plus jeune âge. A la recherche de nouvelle compétence, j'ai réalisé un DUT Informatique.
                    J'ai ensuite cherché à pousser mes compétences dans le milieu du web, un milieu que j'affectionne, à l'école MIAGE qui me permettra de déboucher sur un Master en Informatique spécialisé en Big Data et nouvelles technologies.<br/><br/>

                    <div className={"card-info"}>
                        <div className={"container-img"}>
                            <img src={"assets/logoMantaria.png"} alt={"logoMantaria"} className={"img-card"}/>
                        </div>
                        <div className={"first-part-text"}>
                            Je suis également co-fondateur d'un studio de graphisme : Mantaria Studio !
                            Nous sommes une équipe d'une dizaine de designer, nous réalisons des logos, des bannières, des illustrations, des vidéos et bien plus encore !<br/><br/>
                        </div>
                        <div className={"second-part-text"}>
                            Je m'occupe principalement du côté développement et je gère toute une équipe de prestataire afin de répondre aux mieux à vos demande.
                        </div>
                    </div>
                    <br/>

                    Vous pouvez suivre l'avancement de mon travail par mes différents réseaux :<br/>
                    - GitHub : https://github.com/pierrebihannic ainsi que de mon compte privée : https://github.com/PierreBH<br/>
                    - Mail pro : pierre.bihannic@etu.unice.fr</p>
                <div className={"logo-container"}>
                    <div className={"card"}>
                        <div className={"card-icon"}>
                            <IconCertificate />
                        </div>
                        <div className={"card-title"}>
                            <h3>Etudiant</h3>
                            <div className={"card-content"}>
                                <p>Master 2 - MBDS</p>
                            </div>
                        </div>
                    </div>
                    <div className={"card"}>
                        <div className={"card-icon"}>
                            <IconAppWindow />
                        </div>
                        <div className={"card-title"}>
                            <h3>3 ans</h3>
                            <div className={"card-content"}>
                                <p>expérience en web</p>
                            </div>
                        </div>
                    </div>
                    <div className={"card"}>
                        <div className={"card-icon"}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-brand-aws" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M17 18.5a15.198 15.198 0 0 1 -7.37 1.44a14.62 14.62 0 0 1 -6.63 -2.94" />
                                <path d="M19.5 21c.907 -1.411 1.451 -3.323 1.5 -5c-1.197 -.773 -2.577 -.935 -4 -1" />
                                <path d="M3 11v-4.5a1.5 1.5 0 0 1 3 0v4.5" />
                                <path d="M3 9h3" />
                                <path d="M9 5l1.2 6l1.8 -4l1.8 4l1.2 -6" />
                                <path d="M18 10.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75" />
                            </svg>
                        </div>
                        <div className={"card-title"}>
                            <h3>AWS Academy</h3>
                            <div className={"card-content"}>
                                <p>Développement Cloud & Infrastructure</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className={"right"}>
                <div className={"container-img"}>
                    <img src={"assets/avatars.png"} alt={"img-profil"} className={"img-profil"}/>
                    <div className={"background-edge"} id={"edge-3"}/>
                    <div className={"background-edge"} id={"edge-2"}/>
                    <div className={"background-edge"} />
                </div>
            </div>

        </div>
    )
}